import { render, staticRenderFns } from "./lk-title-link.vue?vue&type=template&id=44eb6c0e&"
import script from "./lk-title-link.vue?vue&type=script&lang=js&"
export * from "./lk-title-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-title-link/lk-title-link.vue
// module id = 111
// module chunks = 0